import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_coupon_ext_RowClass} from '../../../dbschema';
import {bl_fi_mst_coupon_line_RowClass} from '../../../dbschema';

export class CouponSerialNumberContainerModel extends BaseContainerModel {
  bl_fi_mst_coupon_exts: bl_fi_mst_coupon_ext_RowClass[] = [];
  bl_fi_mst_coupon_line: bl_fi_mst_coupon_line_RowClass;
}
